import * as React from 'react';
import MediaQuery from 'react-responsive';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import { OrderStatus, TravellerFieldEnum } from '@websky/graphql';
import { useToggleable } from '../../../hooks';
import { Included, Person, TicketFilled, WarningRounded } from '../../../Icons';
import { useTranslation } from 'react-i18next';
import WaitingPaymentText from '../WaitingPaymentText/WaitingPaymentText';
import FlightInfoCardControls from '../FlightInfoCardControls/FlightInfoCardControls';
import Button from '../../../Button';
import ControlsWrapper from '../FlightInfoCardControls/ControlsWrapper';
const FlightInfoCardHeader = ({ order, onPassengerDetails, onDownloadTickets }) => {
    const { FlightInfoCardHeader: css } = useTheme('FlightInfoCard');
    const { isOpen, close, open } = useToggleable(false);
    const { t } = useTranslation('FlightInfoCard');
    const travellers = order.travellers.map(traveller => {
        var _a, _b;
        const firstName = (_a = traveller.values.find(value => value.type === TravellerFieldEnum.FirstName)) === null || _a === void 0 ? void 0 : _a.value, lastName = (_b = traveller.values.find(value => value.type === TravellerFieldEnum.LastName)) === null || _b === void 0 ? void 0 : _b.value;
        return `${firstName || ''} ${lastName || ''}`.toLowerCase();
    });
    return (React.createElement("header", { className: cn(css.header) },
        React.createElement("h2", { className: cn(css.header__title) },
            t('Booking'),
            " \u2116 ",
            order.locator),
        React.createElement("div", { className: cn(css.header__info) },
            React.createElement("div", { className: cn(css.header__infoItem) },
                order.status === OrderStatus.Booked && (React.createElement("p", { className: cn(css.header__text, css.header__payment) },
                    React.createElement("span", { className: cn(css.header__textIcon) }, WarningRounded),
                    React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
                        "\u2116 ",
                        order.locator,
                        React.createElement("br", null)),
                    React.createElement(WaitingPaymentText, { timelimit: order.timelimit }))),
                order.status === OrderStatus.Confirmed && (React.createElement("p", { className: cn(css.header__text, css.header__payment_confirmed) },
                    React.createElement("div", { className: css.info__wrapper },
                        React.createElement("span", { className: cn(css.header__textIcon) }, Included),
                        React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
                            "\u2116 ",
                            order.locator,
                            ", "),
                        t('Confirmed')),
                    React.createElement("div", { className: css.button__wrapper },
                        React.createElement(Button, { className: cn(css.header__infoButton), variant: "text", onClick: open }, t('Manage order')),
                        React.createElement(ControlsWrapper, { order: order }, controls => {
                            return (React.createElement(FlightInfoCardControls, { controls: controls, isOpened: isOpen, onClose: close, outsideClickIgnoreClass: cn(css.header__infoButton) }));
                        })))),
                order.status === OrderStatus.Cancelled && (React.createElement("p", { className: cn(css.header__text, css.header__payment_cancelled) },
                    React.createElement("span", { className: cn(css.header__textIcon) }, WarningRounded),
                    React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
                        "\u2116 ",
                        order.locator,
                        ", "),
                    t('Cancelled')))),
            React.createElement("div", { className: cn(css.header__infoItem) },
                React.createElement("p", { className: cn(css.header__text) },
                    React.createElement("span", { className: cn(css.header__textIcon) }, Person),
                    React.createElement("span", null, travellers.map(traveller => (React.createElement("span", { className: css.header__traveller, key: traveller }, traveller)))),
                    React.createElement(Button, { className: cn(css.header__infoButton), variant: "text", onClick: onPassengerDetails }, t('Details')))),
            React.createElement("div", { className: cn(css.header__infoItem) }, order.status === OrderStatus.Confirmed && (React.createElement("p", { className: cn(css.header__text) },
                React.createElement("span", { className: cn(css.header__textIcon) }, TicketFilled),
                t('Tickets and documents'),
                React.createElement(Button, { className: cn(css.header__infoButton), variant: "text", onClick: onDownloadTickets }, t('Download'))))))));
};
export default FlightInfoCardHeader;
